module.exports = __webpack_public_path__ + "img/d14c58fee218dc788888e08a60704ec8.png";